import * as z from "zod/v4";

export const createPayout = {
  name: "createPayout" as const,
  input: z.object({ teamId: z.string(), amount: z.number() }),
  output: z.object({ success: z.boolean() }),
};
